// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Smq3v","primary":"Button_primary__XYgy-","secondary":"Button_secondary__QwN49"};